import './LoginComponent.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import {Badge, ButtonGroup} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {DateRange} from 'react-date-range';
import {addDays, addMinutes, addMonths, addYears, isBefore, subYears, format, parse} from 'date-fns';

import {it} from "date-fns/locale";

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import data from "bootstrap/js/src/dom/data";
import Alert from "react-bootstrap/Alert"; // theme css file

const TicketProcessBuy = ({ticket}) => {
    console.log("TicketProcessBuy");
    console.log(ticket);

    const [step, setStep] = React.useState("quantity");
    const [quantity, setQuantity] = React.useState(1);
    const [index, setIndex] = React.useState(1);
    const [cart, setCart] = React.useState([]);
    const [currentTicket, setCurrentTicket] = React.useState({
        date_start: "",
        date_end: "",
        nickname: "",
        extra_data: []
    });


    const getContent = () => {
        let content = [];
        content.push(<Row>
                <Col xs={12} md={5} sm={12} className="justify-content-center">
                    <div className="d-flex justify-content-center">
                        <h5>Effettua il login</h5>
                    </div>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="Inserisci email"/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Inserisci password"/>
                        </Form.Group>
                        <div className="d-flex justify-content-center">

                            <Button variant="success" type="submit">
                                Entra
                            </Button>
                        </div>
                    </Form>

                </Col>
                <div class="col-md-1 d-flex justify-content-center col-line">

                    <div className="vertical-line"></div>
                </div>
                <Col xs={12} md={5} sm={12} className=" justify-content-center">
                    <div className="d-flex justify-content-center">
                        <h5>Registrati</h5>
                    </div>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="Enter email"/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password"/>
                            <Form.Text className="text-muted">
                                <small className="text-muted">La password deve contenere almeno 8 caratteri</small>
                                <small className="text-muted">La password deve contenere almeno un carattere
                                    MAIUSCOLO</small>
                                <small className="text-muted">La password deve contenere almeno un numero</small>
                            </Form.Text>
                        </Form.Group>
                        <Row>
                            <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control type="text" placeholder="Nome"/>

                        </Form.Group>
                            </Col>
                            <Col>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Cognome</Form.Label>
                            <Form.Control type="text" placeholder="Cognome"/>
                        </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Paese</Form.Label>
                            <Form.Select aria-label="Default select example">
                                <option>Seleziona il paese</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="Accetto i Termini e condizioni d'uso"/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="Confermo di avere più di 18 anni"/>
                        </Form.Group>

                        <div className="d-flex justify-content-center">
                            <Button variant="success" type="submit">
                                Registrati
                            </Button>
                        </div>
                    </Form>

                </Col>

            </Row>
        )
        return content;
    }

    return (
        <div className="login-container">
            {getContent()}
        </div>
    );
};

function getDateEnd(ticket, date) {
    let date_end = date;
    switch (ticket.type) {
        case "HOURLY":
            /*            setDataDatePicker((prev) => ({
                            ...prev,
                            includeTimes: formatCalendarIncludedTimes(
                                dataDatePicker.calendar,
                                date,
                                'open'
                            ),
                            startDate: isBefore(new Date(), date) === true ? null : date,
                            endDate: addMinutes(date, timeIntervals)
                        }));*/
            return;
        // case "DAILY":
        // setDataDatePicker((prev) => ({ ...prev, startDate: date, endDate: date }));
        // return;
        case "TWODAYS":
            date_end = addDays(date, 1);
            break;
        case "THREEDAYS":
            date_end = addDays(date, 2);
            break;
        case "FOURDAYS":
            date_end = addDays(date, 3);
            break;
        case "WEEKDAYS":
            date_end = addDays(date, 4);
            break;
        case "WEEKLY":
            date_end = addDays(date, 6);
            break;
        case "TWOWEEKS":
            date_end = addDays(date, 13);
            break;
        case "MONTHLY":
            date_end = addMonths(date, 1);
            break;
        case "TRIMESTER":
            date_end = addMonths(date, 2);
            break;
        case "SEASONAL":
        case "SEMIANNUAL":
            date_end = addMonths(date, 6);
            break;
        case "YEARLY":
            date_end = addYears(date, 1);
            break;
        case "BIANNUAL":
            date_end = subYears(date, 2);
            break;
        case "TRIENNIAL":
            date_end = addYears(date, 3);
            break;
    }
    if (date_end > parse(ticket.date_end_validity, "dd/MM/yyyy", new Date()))
        date_end = parse(ticket.date_end_validity, "dd/MM/yyyy", new Date());

    return date_end;
}

export default TicketProcessBuy;
